import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'

import { Tabs, TabsItemProps } from '@/components'
import { ROUTES_ADMIN } from '@/router'

import styles from './supplier-tabs.module.css'

export const SupplierTabs = () => {
  const { t } = useTranslation('screenSuppliers')

  const location = useLocation()
  const navigate = useNavigate()

  const isSupplierForecasts = location.pathname.includes('/supplier-forecasts')

  const tabs: TabsItemProps[] = [
    {
      title: t('tabSuppliers'),
      isActive: !isSupplierForecasts,
      onSelect: () =>
        isSupplierForecasts
          ? navigate(`/${ROUTES_ADMIN.SUPPLY.SUPPLIERS.SUPPLIERS.path}`)
          : undefined,
    },
    {
      title: t('tabSupplierProducts'),
      isActive: isSupplierForecasts,
      onSelect: () =>
        !isSupplierForecasts
          ? navigate(
              `/${ROUTES_ADMIN.SUPPLY.SUPPLIERS.SUPPLIER_FORECASTS.path}`,
            )
          : undefined,
    },
  ]
  return (
    <div className={styles.tab}>
      <Tabs items={tabs} />
    </div>
  )
}
